import React from 'react';
import { ShieldCheckIcon, CpuChipIcon } from '@heroicons/react/24/outline';
import { Card } from '../../components/common/Card';

const AISettings = () => {
  return (
    <div className="space-y-6">
      {/* Current Status */}
      <Card>
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Claude AI Státusz</h2>
            <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-400">
              <ShieldCheckIcon className="w-4 h-4 mr-1" />
              Konfigurálva
            </div>
          </div>

          <div className="text-sm text-gray-600 dark:text-gray-400">
            <p>Az AI funkció aktív és használatra kész az alapértelmezett API kulccsal.</p>
          </div>
        </div>
      </Card>

      {/* System Configuration Info */}
      <Card>
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Rendszer Konfiguráció</h2>
          
          <div className="space-y-4">
            {/* System Status */}
            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
              <div className="flex items-center mb-2">
                <CpuChipIcon className="w-5 h-5 text-green-600 dark:text-green-400 mr-2" />
                <h3 className="text-sm font-medium text-green-900 dark:text-green-300">AI Funkció Aktív</h3>
              </div>
              <p className="text-sm text-green-800 dark:text-green-400">
                A Claude AI integráció konfigurálva van és használatra kész. Az alapértelmezett API kulcs a rendszergazda által lett beállítva.
              </p>
            </div>

            {/* Features */}
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
              <h3 className="text-sm font-medium text-blue-900 dark:text-blue-300 mb-2">Elérhető Funkciók</h3>
              <div className="text-sm text-blue-800 dark:text-blue-400">
                <ul className="list-disc list-inside space-y-1">
                  <li>Automatikus ajánlat generálás</li>
                  <li>Markdown formátumú kimenet</li>
                  <li>Testreszabható paraméterek</li>
                  <li>Egyedi instrukciók támogatása</li>
                </ul>
              </div>
            </div>

            {/* Usage Info */}
            <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
              <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Használat</h3>
              <div className="text-sm text-gray-600 dark:text-gray-400">
                <p>Az AI ajánlat generátor elérhető a <strong>Beállítások → AI Árajánlatok</strong> menüpontban, vagy közvetlenül a navigációs sávban.</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Usage Information */}
      <Card>
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Használati információk</h2>
          
          <div className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
            <div className="flex items-start space-x-2">
              <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
              <p>Az AI ajánlat generátor Claude 3.5 Sonnet modellt használ</p>
            </div>
            <div className="flex items-start space-x-2">
              <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
              <p>A generált ajánlatok Markdown formátumban készülnek</p>
            </div>
            <div className="flex items-start space-x-2">
              <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
              <p>Minden generált ajánlat automatikusan mentésre kerül</p>
            </div>
            <div className="flex items-start space-x-2">
              <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
              <p>A token használat nyomon követésre kerül</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AISettings;